import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-waiting-dialog',
  templateUrl: './waiting-dialog.component.html',
  styleUrls: ['./waiting-dialog.component.scss']
})
export class WaitingDialogComponent implements OnInit {

  public info;

  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.info = data;
    console.log('waiting dialog data', data);
  }

  ngOnInit(): void {
  }

}
